<div class="information-container" [ngClass]="typeDisclaimer" [class.hidden-background]="!showBackground">
  <span *ngIf="showIcon" class="icon" [ngClass]="typeDisclaimer"></span>
  <div class="information-text">
    <p class="text-label" [ngClass]="font?.size">{{ description | translate }}</p>
  </div>
</div>
